import type { Dictionnaire } from '../type';

export const fil: Dictionnaire['fil'] = {
  erreurs: {
    supprimerLesSiens: 'You can only delete your own posts',
    pasTaReponse: "This reply isn't yours",
    commentaireVide: 'Empty comment',
    vide: 'Write something before posting',
    tropLong: (max: number) => `${max} characters maximum`,
  },
  commun: {
    retirerLike: 'Unlike',
    liker: 'Like',
    likerReponse: 'Like this reply',
    retirerSignet: 'Remove from bookmarks',
    enregistrer: 'Save to my bookmarks',
    actionsPost: 'Post actions',
    actionsReponse: 'Reply actions',
    voirPhoto: 'View photo full screen',
    photoDe: (auteur: string) => `Photo posted by ${auteur}`,
    supprimerPostQ: 'Delete this post?',
    supprimerPost: 'Delete this post',
    supprimerReponseQ: 'Delete this reply?',
    supprimerReponse: 'Delete this reply',
    signaler: 'Report content',
    partager: 'Share',
    suppressionImpossible: "Couldn't delete.",
    reponses: 'Replies',
    commenter: 'Comment',
  },
  signets: {
    onglets: {
      posts: 'Posts',
      evenements: 'Events',
    },
    titre: 'My bookmarks',
    aucunPost: 'No saved posts',
    aucunPostAide: 'Save a post or a reply to find it here.',
    aucuneSortie: 'No saved events',
    aucuneSortieAide: "Tap the bookmark on an event's page to keep it handy.",
    compte: (n: number) => `${n} saved`,
  },
  cloche: {
    verbes: {
      like: 'liked your post',
      commentaire: 'replied to your post',
      mention: 'mentioned you in a post',
      signet: 'saved your post',
    },
    titre: 'Notifications',
    activite: 'Activity',
    vide: 'No activity yet',
    nouvelles: (n: number) => `Notifications · ${n} new`,
  },
  composeur: {
    annulerReponse: 'Stop replying to this reply',
    ecrire: 'Write a comment...',
    envoyer: 'Send',
    reponseA: 'Replying to',
    repondreA: (nom: string) => `Reply to ${nom}...`,
  },
  reponse: {
    voirReponses: (n: number) => `View ${n} replies`,
    repondreA: (nom: string) => `Reply to ${nom}`,
  },
  fil: {
    envoiImpossible: "Couldn't send the reply",
    partagerReponse: 'Share this reply',
    vide: 'No replies',
    videAide: 'Be the first to reply to this comment.',
  },
  commentaires: {
    envoiImpossible: "Couldn't send the comment",
    titre: 'Comments',
    vide: 'No comments',
    videAide: 'Be the first to react to this post.',
  },
  composer: {
    impossible: "Couldn't publish",
    titre: 'New post',
    publier: 'Post',
    lieu: 'Place',
    evenement: 'Event',
    photoJointe: 'Photo attached to the post',
    retirerPhoto: 'Remove photo',
    visible: 'Visible to the whole server',
    remplacerPhoto: 'Replace photo',
    ajouterPhoto: 'Add a photo',
    ajouterLieu: 'Add a place',
    joindreEvenement: 'Attach an event',
    ajouterCeLieu: 'Add this place',
    retirerLieu: 'Remove place',
    termine: 'Done',
    retirer: 'Remove',
    quelEvenement: 'Which event?',
    aucunEvenement: 'No upcoming events',
    aucunEvenementAide: 'Create one from the Events tab.',
    quoiDeNeuf: (lieu: string) => `What's new in ${lieu}?`,
    lieuChoisi: (lieu: string) => `Place: ${lieu}`,
    evenementChoisi: (titre: string) => `Event: ${titre}`,
    ouDans: (lieu: string) => `Where in ${lieu}?`,
  },
  ecran: {
    vues: {
      pourToi: 'For you',
      recent: 'Recent',
    },
    supprime: 'Post deleted.',
    rechercher: 'Search posts…',
    rechercherLabel: 'Search the feed',
    ecrire: 'Write a post',
    masquerQ: 'Hide this post?',
    masquer: 'Hide this post',
    aucunResultat: 'No results',
    vide: 'The feed is still empty',
    videAide: 'Be the first to start a conversation on this server.',
    premierPost: 'Write the first post',
    rienNeCorrespond: (recherche: string) => `Nothing matches “${recherche}” on this server.`,
  },
  mesPosts: {
    titre: 'My posts',
    voirQuiAAime: 'See who liked it',
    jaime: 'Likes',
    personne: 'No one has liked this post yet.',
    vide: 'No posts',
    videAide: 'Your posts will appear here.',
    compte: (n: number) => `${n} post${n === 1 ? '' : 's'}`,
  },
};
